import './App.css';
import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ChatAppPage from './pages/ChatAppPage';
import AuthContext from './context/auth-context';
import Layout from './components/Layouts/Layout';

function App() {
	const authCtx = useContext(AuthContext);
	const isLoggedIn = authCtx.isLoggedIn;

	return (
		<Layout>
			{isLoggedIn && (
				<Routes>
					<Route path='/login' element={<LoginPage />} exact />
					<Route path='/signup' element={<SignupPage />} exact />
					<Route path='/chatapp' element={<ChatAppPage />} exact />
				</Routes>
			)}
			{!isLoggedIn && (
				<Routes>
					<Route path='/' element={<Navigate to='/login' />} exact />
					<Route path='/login' element={<LoginPage />} exact />
					<Route path='/signup' element={<SignupPage />} exact />
					<Route path='*' element={<Navigate to='/login' />} />
				</Routes>
			)}
		</Layout>
	);
}

export default App;
